import { useEffect } from 'react';

const DEFAULT_OG_IMAGE = 'https://pulmakivi.fi/featureimage_norppa.png';

export default function usePageMeta({ title, description, canonical, image }) {
  useEffect(() => {
    document.title = title;

    if (description) {
      document.querySelector('meta[name="description"]')?.setAttribute('content', description);
      document.querySelector('meta[property="og:description"]')?.setAttribute('content', description);
      document.querySelector('meta[name="twitter:description"]')?.setAttribute('content', description);
    }

    if (canonical) {
      document.querySelector('link[rel="canonical"]')?.setAttribute('href', canonical);
      document.querySelector('meta[property="og:url"]')?.setAttribute('content', canonical);
    }

    const ogImage = image ? `https://pulmakivi.fi${image}` : DEFAULT_OG_IMAGE;
    document.querySelector('meta[property="og:image"]')?.setAttribute('content', ogImage);
    document.querySelector('meta[name="twitter:image"]')?.setAttribute('content', ogImage);

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', title);
    const twTitle = document.querySelector('meta[name="twitter:title"]');
    if (twTitle) twTitle.setAttribute('content', title);
  }, [title, description, canonical, image]);
}
